import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { db, doc, getDoc, updateDoc } from '../firebase';
import MessageList from '../components/MessageList';
import MessageInput from '../components/MessageInput';
import './ChatConversation.css';

const ChatConversation = () => {
  const { friendId } = useParams();
  const navigate = useNavigate();
  const accountNumber = localStorage.getItem('accountNumber');
  const [friendName, setFriendName] = useState('');
  const [story, setStory] = useState(null);

  // Redirect if not logged in
  useEffect(() => {
    if (!accountNumber) {
      navigate('/');
    }
  }, [accountNumber, navigate]);

  // Fetch friend's name from Firestore
  useEffect(() => {
    const fetchFriendName = async () => {
      const friendRef = doc(db, 'users', friendId);
      const friendSnap = await getDoc(friendRef);
      if (friendSnap.exists()) {
        setFriendName(friendSnap.data().name || 'Unknown');
      } else {
        setFriendName('Unknown');
      }
    };
    fetchFriendName();
  }, [friendId]);

  // Fetch friend's story and mark it as seen if necessary
  useEffect(() => {
    const fetchStory = async () => {
      const storyRef = doc(db, 'stories', friendId);
      const storySnap = await getDoc(storyRef);
      if (storySnap.exists()) {
        const data = storySnap.data();
        console.log("Fetched story for friendId", friendId, ":", data);
        setStory(data);
        // Mark as seen if the current user hasn't seen it
        if (!data.seenBy.includes(accountNumber)) {
          await updateDoc(storyRef, { seenBy: [...data.seenBy, accountNumber] });
        }
      } else {
        console.log("No story found for friendId:", friendId);
        setStory(null);
      }
    };
    fetchStory();
  }, [friendId, accountNumber]);

  return (
    <div className="chat-container">
      <button className="home-button" onClick={() => navigate('/home')}>🏠 Home</button>
      <h2>Chat with {friendName}</h2>
      
      {/* Display the friend's story if available */}
      {story ? (
        <div className="story-message">
          <p><strong>{friendName}'s Story:</strong> {story.text}</p>
        </div>
      ) : (
        <div className="no-story">
          <p>No story available</p>
        </div>
      )}

      <MessageList accountNumber={accountNumber} selectedFriend={friendId} />
      <MessageInput accountNumber={accountNumber} selectedFriend={friendId} />
    </div>
  );
};

export default ChatConversation;
